// extracted by mini-css-extract-plugin
export var core = "Footer-module--core--340e5";